// NOTE: use to be env as /v3/html | /v3/src
const environment = ENV;
// Known as dev | staging | app
const tier = "production" === environment ? "app" : "development" === environment ? "dev" : environment;
const queryString = window.location.search;

// Set hosts
const apiV3Host = API_V3_HOST;
const apiHost = API_HOST;
const appHost = APP_HOST;

export {environment, tier, queryString, apiV3Host, apiHost, appHost};
export default environment;
